export const nav = {
    groups: {
        overview: "Overview",
        sales: "Sales",
        catalog: "Catalog",
        inventory: "Inventory",
        purchasing: "Purchasing",
        finance: "Finance",
        pos: "Point of sale",
        settings: "Settings",
        account: "Account",
    },
    menu: "Menu",
    dashboard: "Dashboard",
    auditLog: "Audit log",
    settings: "Settings",
    sessions: "Sessions",
    security: "Security",
    businessSettings: "Business settings",
    locations: "Locations",
    products: "Products",
    catalogSetup: "Catalog setup",
    stock: "Stock",
    stockAdjustments: "Stock adjustments",
    transfers: "Transfers",
    stockCounts: "Stock counts",
    orders: "Orders",
    orderCalls: "Call list",
    deliveryZones: "Delivery zones",
    orderReturns: "Returns",
    rtoParcels: "Returned parcels",
    cod: "COD reconciliation",
    fraud: "Fraud check",
    onlineStore: "Online store",
    coupons: "Coupons",
    appearance: "Shop appearance",
    shopPages: "Shop pages",
    shopThemes: "Shop themes",
    billing: "Plan & billing",
    support: "Support access",
    dataAccount: "Data & account",
    help: "Help",
    staff: "Staff",
    payments: "Payments",
    posReview: "POS review",
    posDevices: "POS devices",
    couriers: "Couriers",
    paymentAccounts: "Payment accounts",
    reports: "Reports",
    expenses: "Expenses",
    cashbook: "Cashbook",
    customers: "Customers",
    onlineAccounts: "Online accounts",
    suppliers: "Suppliers",
    purchaseOrders: "Purchase orders",
    goodsReceipts: "Goods received",
    purchaseReturns: "Supplier returns",
    payables: "Payables",
    imports: "Import / export",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    preferences: "Preferences",
    account: "Account",
    welcome: "Welcome, {{name}}",
    dashboardBody: "Sales, stock and orders for this business will appear here.",
};
//# sourceMappingURL=nav.js.map